import * as React from 'react';
import { Tabs, Tab, Loader, Alert } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { connect, withIntl, statusLoading } from '@grandvisionhq/state';
import { fetchDetail, updateSubscriptionAddress, saveSubscriptionAddress, resetSubscriptionAddress, setSubscriptionFormIsEditMode, setSubscriptionFormIsModalOpen } from '../actions.js';
import { getSubscriptionDetailCall, getSubscriptionDetail, getSubscriptionForm } from '../selectors.js';
import CurrentPlanContainer from './CurrentPlan/CurrentPlanContainer.js';
import Delivery from './Delivery/Delivery.js';
import Payments from './Payments/Payments.js';

const hashNames = [
    'details',
    'delivery',
    'payments'
];
class SubscriptionDetail extends React.Component {
    componentDidMount() {
        const { subscriptionId , fetchDetail: fetchDetail1  } = this.props;
        fetchDetail1({
            subscriptionId
        });
        this.setActiveTab();
    }
    componentDidUpdate() {
        this.setActiveTab();
    }
    render() {
        const { detail , detailCall , intl: { getLabel  } , subscriptionForm , staticsUrl , subscriptionId , updateSubscriptionAddress: updateSubscriptionAddress1 , saveSubscriptionAddress: saveSubscriptionAddress1 , resetSubscriptionAddress: resetSubscriptionAddress1 , setSubscriptionFormIsEditMode: setSubscriptionFormIsEditMode1 , setSubscriptionFormIsModalOpen: setSubscriptionFormIsModalOpen1 ,  } = this.props;
        const { activeTabIndex  } = this.state;
        const LABEL_PREFIX = 'account.subscription.details';
        if (detail && detail.id === subscriptionId) {
            return /*#__PURE__*/ React.createElement("div", {
                className: "subscription-details"
            }, /*#__PURE__*/ React.createElement(Heading, {
                variant: "small",
                component: "h1",
                className: "subscription-details__title"
            }, getLabel(`${LABEL_PREFIX}.title`)), detail.custom && detail.custom.membershipId && /*#__PURE__*/ React.createElement("p", {
                className: "subscription-details__membership-id"
            }, `${getLabel(`${LABEL_PREFIX}.membership.id`)}: ${detail.custom.membershipId}`), /*#__PURE__*/ React.createElement("div", {
                className: "subscription-details__tabs"
            }, /*#__PURE__*/ React.createElement(Tabs, {
                onChange: this.handleTabClick,
                activeTabIndex: activeTabIndex
            }, /*#__PURE__*/ React.createElement(Tab, {
                label: getLabel(`${LABEL_PREFIX}.tabs.currentPlan`)
            }), /*#__PURE__*/ React.createElement(Tab, {
                label: getLabel(`${LABEL_PREFIX}.tabs.deliveryDetails`)
            }), /*#__PURE__*/ React.createElement(Tab, {
                label: getLabel(`${LABEL_PREFIX}.tabs.paymentDetails`)
            }))), /*#__PURE__*/ React.createElement("div", {
                className: "subscription-details__body"
            }, activeTabIndex === 0 && /*#__PURE__*/ React.createElement(CurrentPlanContainer, {
                subscription: detail,
                staticsUrl: staticsUrl,
                className: "subscription-details__tab"
            }), activeTabIndex === 1 && /*#__PURE__*/ React.createElement(Delivery, {
                subscriptionForm: subscriptionForm,
                onChange: updateSubscriptionAddress1,
                onCancel: resetSubscriptionAddress1,
                onSave: saveSubscriptionAddress1,
                onEditModeChange: setSubscriptionFormIsEditMode1,
                onModalClose: ()=>{
                    setSubscriptionFormIsModalOpen1(false);
                },
                subscription: detail
            }), activeTabIndex === 2 && /*#__PURE__*/ React.createElement(Payments, {
                subscription: detail,
                className: "subscription-payments__tab"
            })));
        } else if (statusLoading(detailCall)) {
            return /*#__PURE__*/ React.createElement(Loader, null);
        } else {
            return /*#__PURE__*/ React.createElement(Alert, {
                type: "error",
                title: getLabel('account.subscriptions.errors.general')
            });
        }
    }
    constructor(...args){
        super(...args);
        this.state = {
            activeTabIndex: 0
        };
        this.handleTabClick = (index)=>{
            this.setState({
                activeTabIndex: index
            });
            history.replaceState(null, '', `#${hashNames[index]}`);
        };
        this.setActiveTab = ()=>{
            const hash = window.location.hash.replace(/^#/, '');
            const hashIndex = hashNames.indexOf(hash);
            if (hashIndex > -1 && this.state.activeTabIndex !== hashIndex) {
                this.setState({
                    activeTabIndex: hashIndex
                });
            }
        };
    }
}
const WrappedWithIntl = withIntl(SubscriptionDetail);
const mapStateToProps = (state)=>({
        detailCall: getSubscriptionDetailCall(state),
        detail: getSubscriptionDetail(state),
        subscriptionForm: getSubscriptionForm(state)
    })
;
const mapDispatchToProps = {
    fetchDetail,
    updateSubscriptionAddress,
    saveSubscriptionAddress,
    resetSubscriptionAddress,
    setSubscriptionFormIsEditMode,
    setSubscriptionFormIsModalOpen
};
var SubscriptionDetail$1 = connect(mapStateToProps, mapDispatchToProps)(WrappedWithIntl);

export { SubscriptionDetail, SubscriptionDetail$1 as default, mapDispatchToProps, mapStateToProps };
//# sourceMappingURL=SubscriptionDetail.js.map
